import database from "../firebase/firebase";
// Add Transaction will return the command type and the data for the reducer
// Reducer will create new transaction and add it to the initial state
export const Add_Transaction = (
    transaction
) => ({
    type: "ADD_TRANSACTION",
    transaction
});

export const Add_Transaction_With_Firebase = (transactionData = {}) => {
    return (dispatch, getState) => {
        // This syntax here is called object destructuring
        // It assign the transaction name and transaction amount with the data inside transactionData
        // If transaction data is empty {} then all variable will be set to the default state which is ""
        const user_id = getState().Auth.uid;

        const {
            transaction_name = "",
            transaction_amount = ""
        } = transactionData;
        const transaction = {transaction_name, transaction_amount};

        // The return below is used to activate callback
        return database.ref(`transaction/${user_id}/user_data`).push(transaction).then((ref) => {
            dispatch(Add_Transaction({
                id: ref.key,
                ...transaction
            }));
        });
    }
};

// Remove Transaction will return the command type and the id for the reducer
// Reducer will remove the transaction based on the id provided
export const Remove_Transaction = ({id} = {}) => ({
    type: "REMOVE_TRANSACTION",
    id
});

export const Remove_Transaction_With_Firebase = ({id} = {}) => {
    return (dispatch, getState) => {
        const user_id = getState().Auth.uid;
        return database.ref(`transaction/${user_id}/user_data/${id}`).remove(() => {
            dispatch(Remove_Transaction({id}));
            console.log(`Transaction with ID ${id} has been removed.`);
        }).catch((err) => {
            console.log("Failed to remove transaction.");
            console.log(err);
        });
    }
};

export const Update_Transaction = (id, updates) => ({
    type: "UPDATE_TRANSACTION",
    id,
    updates
});

export const Update_Transaction_With_Firebase = (id, updated_transaction_data) => {
    return (dispatch, getState) => {
        const user_id = getState().Auth.uid;

        return database.ref(`transaction/${user_id}/user_data/${id}`).update({
           ...updated_transaction_data
        }).then(() => {
            dispatch(Update_Transaction(id, updated_transaction_data));
            console.log(`Transaction with ID ${id} has been updated.`);
        }).catch((err) => {
            console.log(`Failed to update transaction data with ID ${id}.`);
            console.log(err);
        });
    }
};

export const Set_Transactions = (transactions) => ({
    type: "SET_TRANSACTIONS",
    transactions
});

export const Refresh_Local_Transaction_Data_With_Firebase = () => {
    return (dispatch, getState) => {
        const user_id = getState().Auth.uid;

        return database.ref(`transaction/${user_id}/user_data`).once("value", (snapshot) => {
            const transactions = [];

            snapshot.forEach((single_snapshot) => {
                transactions.push({
                    id: single_snapshot.key,
                    ...single_snapshot.val()
                });
            });

            dispatch(Set_Transactions(transactions));
        });
    }
};